export const KEYS = {
  VOTE_LIST: 'VOTE_LIST',
};
